<template>
<div class="writeCardConfig table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">写号配置</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="虚拟卡号:">
                <el-input v-model="form.virtualIccid" placeholder="请输入虚拟卡号"></el-input>
            </el-form-item>
            <el-form-item label="IMEI:">
                <el-input v-model="form.imei" placeholder="请输入IMEI"></el-input>
            </el-form-item>
            <el-form-item label="虚拟卡短号:">
                <el-input v-model="form.virtualShortNo" placeholder="请输入虚拟卡短号"></el-input>
            </el-form-item>
            <el-form-item label="实体卡号:">
                <el-input v-model="form.entityCardNo" placeholder="请输入实体卡号"></el-input>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="importData">批量导入</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-delete" class="themed-button" @click="batchDelete">批量删除</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="warning" icon="el-icon-lock" class="themed-button" @click="importFrozenCard">冻结卡导入</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
                         <el-table-column label="虚拟卡号" prop="virtualIccid" show-overflow-tooltip></el-table-column>
             <el-table-column label="虚拟卡短号" prop="virtualShortNo" show-overflow-tooltip></el-table-column>
             <el-table-column label="IMEI" prop="imei" show-overflow-tooltip></el-table-column>
             <el-table-column label="ESIM1" prop="iccid1" show-overflow-tooltip>
                 <template slot-scope="scope">
                     <span v-if="scope.row.iccid1">{{ scope.row.iccid1 }}</span>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
             <el-table-column label="ESIM1冻结状态" width="120" show-overflow-tooltip>
                 <template slot-scope="scope">
                     <div v-if="scope.row.iccid1">
                         <el-tag v-if="scope.row.card1Frozen === 1" type="danger" size="mini">已冻结</el-tag>
                         <el-tag v-else type="success" size="mini">未冻结</el-tag>
                         <el-button
                             v-if="scope.row.card1Frozen === 1"
                             type="success"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_unfreeze1']"
                             :disabled="disabledStatus[scope.row.id + '_unfreeze1']"
                             @click="handleUnfreeze(scope.row, 'iccid1', 1)">
                             解冻
                         </el-button>
                         <el-button
                             v-else
                             type="warning"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_freeze1']"
                             :disabled="disabledStatus[scope.row.id + '_freeze1']"
                             @click="handleFreeze(scope.row, 'iccid1', 1)">
                             冻结
                         </el-button>
                     </div>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
             <el-table-column label="ESIM2" prop="iccid2" show-overflow-tooltip>
                <template slot-scope="scope">
                     <span v-if="scope.row.iccid2">{{ scope.row.iccid2 }}</span>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
             <el-table-column label="ESIM2冻结状态" width="120" show-overflow-tooltip>
                 <template slot-scope="scope">
                     <div v-if="scope.row.iccid2">
                         <el-tag v-if="scope.row.card2Frozen === 1" type="danger" size="mini">已冻结</el-tag>
                         <el-tag v-else type="success" size="mini">未冻结</el-tag>
                         <el-button
                             v-if="scope.row.card2Frozen === 1"
                             type="success"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_unfreeze2']"
                             :disabled="disabledStatus[scope.row.id + '_unfreeze2']"
                             @click="handleUnfreeze(scope.row, 'iccid2', 2)">
                             解冻
                         </el-button>
                         <el-button
                             v-else
                             type="warning"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_freeze2']"
                             :disabled="disabledStatus[scope.row.id + '_freeze2']"
                             @click="handleFreeze(scope.row, 'iccid2', 2)">
                             冻结
                         </el-button>
                     </div>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
             <el-table-column label="ESIM3" prop="iccid3" show-overflow-tooltip>
                <template slot-scope="scope">
                     <span v-if="scope.row.iccid3">{{ scope.row.iccid3 }}</span>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
             <el-table-column label="ESIM3冻结状态" width="120" show-overflow-tooltip>
                 <template slot-scope="scope">
                     <div v-if="scope.row.iccid3">
                         <el-tag v-if="scope.row.card3Frozen === 1" type="danger" size="mini">已冻结</el-tag>
                         <el-tag v-else type="success" size="mini">未冻结</el-tag>
                         <el-button
                             v-if="scope.row.card3Frozen === 1"
                             type="success"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_unfreeze3']"
                             :disabled="disabledStatus[scope.row.id + '_unfreeze3']"
                             @click="handleUnfreeze(scope.row, 'iccid3', 3)">
                             解冻
                         </el-button>
                         <el-button
                             v-else
                             type="warning"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_freeze3']"
                             :disabled="disabledStatus[scope.row.id + '_freeze3']"
                             @click="handleFreeze(scope.row, 'iccid3', 3)">
                             冻结
                         </el-button>
                     </div>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
             <el-table-column label="USIM" prop="iccid4" show-overflow-tooltip>
                <template slot-scope="scope">
                     <span v-if="scope.row.iccid4">{{ scope.row.iccid4 }}</span>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
             <el-table-column label="USIM冻结状态" width="120" show-overflow-tooltip>
                 <template slot-scope="scope">
                     <div v-if="scope.row.iccid4">
                         <el-tag v-if="scope.row.card4Frozen === 1" type="danger" size="mini">已冻结</el-tag>
                         <el-tag v-else type="success" size="mini">未冻结</el-tag>
                         <el-button
                             v-if="scope.row.card4Frozen === 1"
                             type="success"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_unfreeze4']"
                             :disabled="disabledStatus[scope.row.id + '_unfreeze4']"
                             @click="handleUnfreeze(scope.row, 'iccid4', 4)">
                             解冻
                         </el-button>
                         <el-button
                             v-else
                             type="warning"
                             size="mini"
                             style="margin-left: 5px;"
                             :loading="loadingStatus[scope.row.id + '_freeze4']"
                             :disabled="disabledStatus[scope.row.id + '_freeze4']"
                             @click="handleFreeze(scope.row, 'iccid4', 4)">
                             冻结
                         </el-button>
                     </div>
                     <span v-else>-</span>
                 </template>
             </el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="更新时间" prop="updateTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.updateTime) }}
                </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button 
                        type="text" 
                        @click="editRemark(scope.row)"
                        :disabled="loadingStatus[scope.row.id + '_remark']">
                        {{ scope.row.remark || '编辑备注' }}
                    </el-button>
                </template>
            </el-table-column>
                         <el-table-column label="操作" width="150" fixed="right">
                 <template slot-scope="scope">
                     <el-button
                         type="primary"
                         class="themed-button"
                         size="mini"
                         :loading="loadingStatus[scope.row.id + '_adjust']"
                         :disabled="disabledStatus[scope.row.id + '_adjust']"
                         @click="handleAdjustOrder(scope.row)">
                         调整顺序
                     </el-button>
                     
                     <el-button
                         type="danger"
                         class="themed-button"
                         size="mini"
                         :loading="loadingStatus[scope.row.id + '_delete']"
                         :disabled="disabledStatus[scope.row.id + '_delete']"
                         @click="handleDelete(scope.row)">
                         删除
                     </el-button>
                 </template>
             </el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 导入弹框 -->
    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="600px" @close="closeImportDialog">
        <el-form label-position="right" label-width="180px" style="max-height:500px;overflow:auto">
            <el-form-item label="上传文件（excel）:" required>
                <input class="file-input" type="file" ref='importFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="卡号信息:">
                <el-input v-model="importInfo" type="textarea" rows="6" placeholder="请输入虚拟卡号 实体卡号1 [实体卡号2] [实体卡号3] [实体卡号4]"></el-input>
                <div style="color:#f00;">请输入虚拟卡号 实体卡号1 [实体卡号2] [实体卡号3] [实体卡号4]</div>
            </el-form-item>
            <el-form-item label="配置类型:" required>
                <el-radio-group v-model="configType">
                    <el-radio :label="1">只写号实名第一张卡，冻结其他卡</el-radio>
                    <el-radio :label="2">按导入顺序实名写号，不冻结</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitImport">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="closeImportDialog">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 批量删除弹框 -->
    <el-dialog title="批量删除" :visible.sync="deleteDialogVisible" width="500px" @close="closeDeleteDialog">
        <div style="color:#f00; margin-bottom: 15px; font-size: 14px;">
            <i class="el-icon-warning"></i> 注意：批量删除写号配置
        </div>
        <el-form label-position="right" label-width="200px" style="max-height:500px;">
            <el-form-item label="上传文件（excel）:">
                <input class="file-input" type="file" ref='deleteFile'/>
                <div class="mt5">
                    <span class="text-color" style="font-size: 12px;">仅支持.xls/.xlsx格式</span>
                </div>
            </el-form-item>
            <el-form-item label="虚拟卡号信息:">
                <el-input v-model="deleteIccidInfo" type="textarea" rows="6" placeholder="请输入虚拟卡号，每行一个"></el-input>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitBatchDelete">导入excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="exportDeleteTemplate">导出excel模板</el-button>
            <el-button type="primary" class="themed-button" @click="closeDeleteDialog">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 调整顺序弹框 -->
    <el-dialog title="调整实名顺序" :visible.sync="adjustOrderVisible" width="600px">
        <div style="margin-bottom: 15px; color: #666;">
            <i class="el-icon-info"></i> 当前虚拟卡号：{{ currentRow.virtualIccid }}
        </div>
        <el-form label-position="right" label-width="120px">
            <el-form-item label="ESIM1:" v-if="currentRow.iccid1">
                <div style="display: flex; align-items: center;">
                    <span style="flex: 1;">{{ tempAdjustData.iccid1 || currentRow.iccid1 }}</span>
                    <el-button 
                        type="primary" 
                        size="mini" 
                        :disabled="!currentRow.iccid2"
                        @click="moveCard('down', 1)">
                        下移
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item label="ESIM2:" v-if="currentRow.iccid2">
                <div style="display: flex; align-items: center;">
                    <span style="flex: 1;">{{ tempAdjustData.iccid2 || currentRow.iccid2 }}</span>
                    <el-button 
                        type="primary" 
                        size="mini" 
                        :disabled="!currentRow.iccid1"
                        @click="moveCard('up', 2)">
                        上移
                    </el-button>
                    <el-button 
                        type="primary" 
                        size="mini" 
                        :disabled="!currentRow.iccid3"
                        @click="moveCard('down', 2)"
                        style="margin-left: 5px;">
                        下移
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item label="ESIM3:" v-if="currentRow.iccid3">
                <div style="display: flex; align-items: center;">
                    <span style="flex: 1;">{{ tempAdjustData.iccid3 || currentRow.iccid3 }}</span>
                    <el-button 
                        type="primary" 
                        size="mini" 
                        :disabled="!currentRow.iccid2"
                        @click="moveCard('up', 3)">
                        上移
                    </el-button>
                    <el-button 
                        type="primary" 
                        size="mini" 
                        :disabled="!currentRow.iccid4"
                        @click="moveCard('down', 3)"
                        style="margin-left: 5px;">
                        下移
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item label="ESIM4:" v-if="currentRow.iccid4">
                <div style="display: flex; align-items: center;">
                    <span style="flex: 1;">{{ tempAdjustData.iccid4 || currentRow.iccid4 }}</span>
                    <el-button 
                        type="primary" 
                        size="mini" 
                        :disabled="!currentRow.iccid3"
                        @click="moveCard('up', 4)">
                        上移
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitAdjustOrder">确 定</el-button>
            <el-button type="primary" class="themed-button" @click="closeAdjustDialog">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 编辑备注弹框 -->
    <el-dialog title="编辑备注" :visible.sync="remarkVisible" width="400px">
        <el-form label-position="right" label-width="80px">
            <el-form-item label="备注:">
                <el-input v-model="remarkForm.remark" type="textarea" rows="4" placeholder="请输入备注信息"></el-input>
            </el-form-item>
        </el-form>
        <div class="align-right">
            <el-button type="primary" class="themed-button" @click="submitRemark">确定</el-button>
            <el-button type="primary" class="themed-button" @click="remarkVisible = false">取 消</el-button>
        </div>
    </el-dialog>

    <!-- 冻结卡导入弹框 -->
    <el-dialog title="冻结卡导入" :visible.sync="frozenCardImportVisible" width="500px" @close="closeFrozenCardImportDialog">
        <div>
            <el-form label-position="left" label-width="120px">
                <el-form-item label="选择excel文件:" required>
                    <el-upload
                        class="upload-demo"
                        action=""
                        :auto-upload="false"
                        :on-change="handleFrozenCardFileChange"
                        :file-list="frozenCardFileList"
                        ref="frozenCardImportFile">
                        <el-button slot="trigger" size="small" type="primary" class="themed-button">选择文件</el-button>
                        <span class="file-tip">未选择文件</span>
                    </el-upload>
                    <div class="file-format-tip">仅支持 xls/xlsx格式</div>
                </el-form-item>
                <el-form-item label="ICCID/短号:">
                    <el-input
                        type="textarea"
                        :rows="6"
                        placeholder="请输入ICCID/短号，每行一个"
                        v-model="frozenCardTextInput">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button type="primary" class="themed-button" @click="handleFrozenCardImport">确认</el-button>
                <el-button type="primary" class="themed-button" @click="exportFrozenCardTemplate">导出excel模板</el-button>
                <el-button @click="frozenCardImportVisible = false" type="primary" class="themed-button">取消</el-button>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { 
    listWriteCardConfig,
    batchImportWriteCardConfig,
    deleteWriteCardConfig,
    unfreezeCard,
    freezeCard,
    adjustCardOrder,
    batchDeleteWriteCardConfig,
    editRemark,
    batchImportFrozenCard
} from '@/api/writeCardManagement/writeCardConfig.js'
import { messageBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    name: 'writeCardConfig',
    mixins: [resize],
    data() {
        return {
            form: {
                virtualIccid: '',
                imei: '',
                virtualShortNo: '',
                entityCardNo: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 导入弹框数据
            importDialogVisible: false,
            importInfo: '',
            configType: '', // 修改为空字符串，并添加必选验证

            // 批量删除弹框数据
            deleteDialogVisible: false,
            deleteIccidInfo: '',

            // 调整顺序弹框数据
            adjustOrderVisible: false,
            currentRow: {},
            tempAdjustData: {}, // 临时存储调换后的数据

            // 编辑备注弹框数据
            remarkVisible: false,
            remarkForm: {
                id: '',
                remark: ''
            },

            // 冻结卡导入弹框数据
            frozenCardImportVisible: false,
            frozenCardFileList: [],
            frozenCardTextInput: '',
            frozenCardUploadFile: null, // 新增：用于存储上传的文件对象

            // 按钮loading状态
            loadingStatus: {},
            // 按钮禁用状态
            disabledStatus: {}
        }
    },
    mounted() {
        this.getList()
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            listWriteCardConfig(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                }
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true
        },

        // 关闭导入弹框时重置数据
        closeImportDialog() {
            this.importDialogVisible = false
            this.importInfo = ''
            this.configType = ''
            // 清空文件输入
            if (this.$refs['importFile']) {
                this.$refs['importFile'].value = ''
            }
        },

        // 提交导入
        submitImport() {
            let file = this.$refs['importFile'].files[0];
            let formData = new FormData();
            
            // 处理写号信息
            if (!file && !this.importInfo.trim()) {
                messageBox(this, '请选择文件或输入写号信息')
                return
            }
            
            // 验证配置类型是否已选择
            if (!this.configType) {
                messageBox(this, '请选择配置类型')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 添加写号信息和配置类型
            formData.append('cardInfos', this.importInfo);
            formData.append('configType', this.configType);
            
            batchImportWriteCardConfig(formData).then(res => {
                if (res.system_result_key == '0') {
                    if (file) {
                        this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.$refs['importFile'].value = '';
                            this.importInfo = '';
                            this.configType = '';
                            this.importDialogVisible = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        this.$message.success(res.system_result_message_key || '导入成功');
                        this.importInfo = '';
                        this.configType = '';
                        this.importDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 导出模板
        exportTemplate() {
            exportTemplate({name: 'importWriteCardConfig.xls'}).then(res => {
                const filename = 'importWriteCardConfig.xls'
                Utils.createDownload(res, filename)
            })
        },

        // 导出批量删除模板
        exportDeleteTemplate() {
            exportTemplate({name: 'importIccidOrShort.xls'}).then(res => {
                const filename = 'importIccidOrShort.xls'
                Utils.createDownload(res, filename)
            })
        },
        
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        },

        // 解冻操作
        handleUnfreeze(row, iccidField, cardIndex) {
            console.log(row)
            const iccid = row[iccidField];
            if (!iccid) return;
            
            this.$set(this.disabledStatus, row.id + '_unfreeze' + cardIndex, true);
            this.$set(this.loadingStatus, row.id + '_unfreeze' + cardIndex, true);
            
            this.$confirm('确认要解冻该卡片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                unfreezeCard({
                    id: row.id,
                    iccid: iccid
                }).then(res => {
                    if (res.system_result_key === '0') {
                        this.$message.success(res.system_result_message_key || '解冻成功');
                        this.getList();
                    } else {
                        this.$message.error(res.system_result_message_key || '解冻失败');
                    }
                }).finally(() => {
                    this.$set(this.loadingStatus, row.id + '_unfreeze' + cardIndex, false);
                    setTimeout(() => {
                        this.$set(this.disabledStatus, row.id + '_unfreeze' + cardIndex, false);
                    }, 10000);
                });
            }).catch(() => {
                this.$message.info('已取消操作');
                this.$set(this.loadingStatus, row.id + '_unfreeze' + cardIndex, false);
                setTimeout(() => {
                    this.$set(this.disabledStatus, row.id + '_unfreeze' + cardIndex, false);
                }, 10000);
            });
        },

        // 冻结操作
        handleFreeze(row, iccidField, cardIndex) {
            const iccid = row[iccidField];
            if (!iccid) return;
            
            this.$set(this.disabledStatus, row.id + '_freeze' + cardIndex, true);
            this.$set(this.loadingStatus, row.id + '_freeze' + cardIndex, true);
            
            this.$confirm('确认要冻结该卡片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                freezeCard({
                    id: row.id,
                    iccid: iccid
                }).then(res => {
                    if (res.system_result_key === '0') {
                        this.$message.success(res.system_result_message_key || '冻结成功');
                        this.getList();
                    } else {
                        this.$message.error(res.system_result_message_key || '冻结失败');
                    }
                }).finally(() => {
                    this.$set(this.loadingStatus, row.id + '_freeze' + cardIndex, false);
                    setTimeout(() => {
                        this.$set(this.disabledStatus, row.id + '_freeze' + cardIndex, false);
                    }, 10000);
                });
            }).catch(() => {
                this.$message.info('已取消操作');
                this.$set(this.loadingStatus, row.id + '_freeze' + cardIndex, false);
                setTimeout(() => {
                    this.$set(this.disabledStatus, row.id + '_freeze' + cardIndex, false);
                }, 10000);
            });
        },

        // 调整顺序操作
        handleAdjustOrder(row) {
            this.currentRow = row;
            // 初始化临时数据，复制当前行的ESIM卡信息
            this.tempAdjustData = {
                iccid1: row.iccid1 || '',
                iccid2: row.iccid2 || '',
                iccid3: row.iccid3 || '',
                iccid4: row.iccid4 || ''
            };
            this.adjustOrderVisible = true;
        },

        // 删除操作
        handleDelete(row) {
            this.$set(this.disabledStatus, row.id + '_delete', true);
            this.$set(this.loadingStatus, row.id + '_delete', true);
            
            this.$confirm('确认要删除该配置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteWriteCardConfig({
                    id: row.id
                }).then(res => {
                    if (res.system_result_key === '0') {
                        this.$message.success(res.system_result_message_key || '删除成功');
                        this.getList();
                    } else {
                        this.$message.error(res.system_result_message_key || '删除失败');
                    }
                }).finally(() => {
                    this.$set(this.loadingStatus, row.id + '_delete', false);
                    setTimeout(() => {
                        this.$set(this.disabledStatus, row.id + '_delete', false);
                    }, 10000);
                });
            }).catch(() => {
                this.$message.info('已取消操作');
                this.$set(this.loadingStatus, row.id + '_delete', false);
                setTimeout(() => {
                    this.$set(this.disabledStatus, row.id + '_delete', false);
                }, 10000);
            });
        },

        // 批量删除操作
        batchDelete() {
            this.deleteDialogVisible = true;
        },

        // 关闭批量删除弹框时重置数据
        closeDeleteDialog() {
            this.deleteDialogVisible = false;
            this.deleteIccidInfo = '';
            // 清空文件输入
            if (this.$refs['deleteFile']) {
                this.$refs['deleteFile'].value = ''
            }
        },

        // 提交批量删除
        submitBatchDelete() {
            let file = this.$refs['deleteFile'].files[0];
            let formData = new FormData();
            
            // 处理ICCID/短号信息
            if (!file && !this.deleteIccidInfo.trim()) {
                messageBox(this, '请选择文件或输入ICCID/短号信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', file);
            }
            
            // 添加ICCID/短号信息
            formData.append('cardInfos', this.deleteIccidInfo);
            
            batchDeleteWriteCardConfig(formData).then(res => {
                if (res.system_result_key == '0') {
                    this.$message.success(res.system_result_message_key || '批量删除成功');
                    this.deleteIccidInfo = ''; // 清空ICCID/短号信息
                    this.deleteDialogVisible = false;
                    this.getList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 冻结卡导入操作
        importFrozenCard() {
            this.frozenCardImportVisible = true;
            this.frozenCardFileList = [];
            this.frozenCardTextInput = '';
            this.frozenCardUploadFile = null;
        },

        // 编辑备注
        editRemark(row) {
            this.remarkForm = {
                id: row.id,
                remark: row.remark || ''
            };
            this.remarkVisible = true;
        },

        // 提交备注
        submitRemark() {
            this.$set(this.disabledStatus, this.remarkForm.id + '_remark', true);
            this.$set(this.loadingStatus, this.remarkForm.id + '_remark', true);
            
            editRemark(this.remarkForm).then(res => {
                if (res.system_result_key === '0') {
                    this.$message.success(res.system_result_message_key || '编辑备注成功');
                    this.remarkVisible = false;
                    this.getList();
                } else {
                    this.$message.error(res.system_result_message_key || '编辑备注失败');
                }
            }).finally(() => {
                this.$set(this.loadingStatus, this.remarkForm.id + '_remark', false);
                setTimeout(() => {
                    this.$set(this.disabledStatus, this.remarkForm.id + '_remark', false);
                }, 10000);
            });
        },

        // 调整顺序弹框中的移动卡片方法
        moveCard(direction, cardIndex) {
            const currentIccid = this.tempAdjustData[`iccid${cardIndex}`] || this.currentRow[`iccid${cardIndex}`];
            if (!currentIccid) {
                this.$message.warning(`ESIM${cardIndex}的ICCID为空，无法移动`);
                return;
            }

            let targetIndex;
            let targetIccid;

            if (direction === 'up') {
                // 向上移动，与上一个ESIM卡调换位置
                targetIndex = cardIndex - 1;
                if (targetIndex < 1) {
                    this.$message.warning(`ESIM${cardIndex}已经是第一个，无法上移`);
                    return;
                }
            } else if (direction === 'down') {
                // 向下移动，与下一个ESIM卡调换位置
                targetIndex = cardIndex + 1;
                if (targetIndex > 4) {
                    this.$message.warning(`ESIM${cardIndex}已经是最后一个，无法下移`);
                    return;
                }
            }

            targetIccid = this.tempAdjustData[`iccid${targetIndex}`] || this.currentRow[`iccid${targetIndex}`];
            if (!targetIccid) {
                this.$message.warning(`目标位置ESIM${targetIndex}的ICCID为空，无法调换`);
                return;
            }

            // 只调换临时数据，不直接修改 currentRow
            this.tempAdjustData[`iccid${cardIndex}`] = targetIccid;
            this.tempAdjustData[`iccid${targetIndex}`] = currentIccid;
        },

        // 提交调整顺序
        submitAdjustOrder() {
            this.$set(this.disabledStatus, this.currentRow.id + '_adjust', true);
            this.$set(this.loadingStatus, this.currentRow.id + '_adjust', true);

            const params = {
                virtualIccid: this.currentRow.virtualIccid,
                newIccid1: this.tempAdjustData.iccid1,
                newIccid2: this.tempAdjustData.iccid2,
                newIccid3: this.tempAdjustData.iccid3,
                newIccid4: this.tempAdjustData.iccid4
            };

            adjustCardOrder(params).then(res => {
                if (res.system_result_key === '0') {
                    this.$message.success(res.system_result_message_key || '调整顺序成功');
                    this.adjustOrderVisible = false;
                    this.tempAdjustData = {}; // 清空临时数据
                    this.getList();
                } else {
                    this.$message.error(res.system_result_message_key || '调整顺序失败');
                }
            }).finally(() => {
                this.$set(this.loadingStatus, this.currentRow.id + '_adjust', false);
                setTimeout(() => {
                    this.$set(this.disabledStatus, this.currentRow.id + '_adjust', false);
                }, 10000);
            });
        },

        // 关闭调整顺序弹框
        closeAdjustDialog() {
            this.adjustOrderVisible = false;
            this.tempAdjustData = {}; // 清空临时数据
        },

        // 冻结卡导入弹框相关方法
        handleFrozenCardFileChange(file) {
            this.frozenCardUploadFile = file.raw; // 存储上传的文件对象，使用file.raw获取原始文件
            this.frozenCardFileList = [file];
        },
        closeFrozenCardImportDialog() {
            this.frozenCardImportVisible = false;
            this.frozenCardFileList = [];
            this.frozenCardTextInput = '';
            this.frozenCardUploadFile = null; // 清空上传的文件对象
        },
        exportFrozenCardTemplate() {
            exportTemplate({name: 'importIccidOrShort.xls'}).then(res => {
                const filename = 'importIccidOrShort.xls'
                Utils.createDownload(res, filename)
            })
        },
        handleFrozenCardImport() {
            let formData = new FormData();
            
            // 处理卡信息
            if (!this.frozenCardUploadFile && !this.frozenCardTextInput.trim()) {
                messageBox(this, '请选择文件或输入卡号信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (this.frozenCardUploadFile) {
                let fileName = this.frozenCardUploadFile.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', this.frozenCardUploadFile);
            }
            
            // 无论是否有文件，都添加卡信息到表单
            formData.append('cards', this.frozenCardTextInput);
            
            batchImportFrozenCard(formData).then(res => {
                if (res.system_result_key == '0') {
                    if (this.frozenCardUploadFile) {
                        this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.frozenCardUploadFile = null;
                            this.frozenCardFileList = [];
                            this.frozenCardTextInput = '';
                            this.frozenCardImportVisible = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        this.$message.success(res.system_result_message_key || '导入成功');
                        this.frozenCardTextInput = '';
                        this.frozenCardImportVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
::v-deep .el-table .cell{padding:0;}
.writeCardConfig {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}

.dialog-footer {
    text-align: center;
    margin-top: 20px;
}

.file-format-tip {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
}

.file-tip {
    margin-left: 10px;
    color: #666;
}

.upload-demo {
    display: inline-block;
}

:deep(.el-upload-list) {
    display: none;
}

:deep(.el-form-item__label) {
    font-weight: normal;
}
</style>
